export default () => {
  return process.env.REACT_APP_API;
}

export const getSpaceUrl = () => {
  return process.env.REACT_APP_S3_URL
}